module.exports = __webpack_public_path__ + "static/media/slider_5_en_sm.16f40b35.svg";